// Local translations
export const T = {
  en_GB: {
    title: "Title (optional)",
    titlePlaceholder: "e.g., Goal List",
    titleHelp: "Optional heading to display above the goal table",
    description: "Description (optional)",
    descriptionPlaceholder: "Enter description...",
    descriptionHelp: "Optional text to display between the title and the table",
    showDescription: "Show goal descriptions",
    showDescriptionHelp:
      "Adds a Description column with each goal's free-text description. The column is printed only when at least one goal has one.",
  },
  nb_NO: {
    title: "Tittel (valgfri)",
    titlePlaceholder: "f.eks. Målliste",
    titleHelp: "Valgfri overskrift som vises over måltabellen",
    description: "Beskrivelse (valgfri)",
    descriptionPlaceholder: "Skriv inn beskrivelse...",
    descriptionHelp: "Valgfri tekst som vises mellom tittelen og tabellen",
    showDescription: "Vis målbeskrivelser",
    showDescriptionHelp:
      "Legger til en beskrivelseskolonne med hvert måls fritekstbeskrivelse. Kolonnen skrives ut bare når minst ett mål har en.",
  },
} as const;
